import React from "react";
import { BUTTON_TYPE_STYLES } from "../Button";
import { useButtonClasses } from "../Button/Button.styles";
import { hasUtilityStyle, useUtilityStyles, UtilityStyle, } from "../hooks/useUtilityStyles";
import { Client } from "../theming/ThemeProvider";
import { useThemeContext } from "../theming/useThemeContext";
import { classNames } from "../utils/classNames";
import { isDefined } from "../utils/isDefined";
export function Link(props) {
    const { styleOptions } = props;
    const { client } = useThemeContext();
    const type = props?.type ?? "default";
    const classes = useButtonClasses(type, hasUtilityStyle(styleOptions, UtilityStyle.Block));
    const utilityStyles = useUtilityStyles(styleOptions);
    const { Element, linkAttributes } = getLinkAttributes(props);
    return (React.createElement(Element, { ...linkAttributes, className: client === Client.Portal
            ? classNames(classes.button, classes.baseButton, utilityStyles.utilities)
            : classNames("btn", `btn-${BUTTON_TYPE_STYLES[type]}`, utilityStyles.utilities), "data-id": props?.dataId, "data-testid": props?.dataTestId }, props.label));
}
export function getLinkAttributes(props) {
    let Element = "a";
    let linkAttributes = {};
    if (isDefined(props.routerLink)) {
        Element = props.routerLink;
        linkAttributes = {
            to: props?.url,
            url: props?.url,
        };
    }
    else {
        linkAttributes = {
            href: props?.url,
        };
    }
    return { linkAttributes, Element };
}
